import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetMealTypePreference = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.MEAL_TYPE_PREFERENCE_LIFESTYLE],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      if (!user) {
        throw new Error("User not found");
      }

      const response =
        await MealPreferencesService.getGeneralMealTypePreferenceApiV1MealPreferencesGeneralMealTypePreferenceGet(
          user.id,
        );

      return response.data;
    },
    retry: (failureCount, error) => {
      if (error && typeof error === "object" && "status" in error) {
        const statusError = error as { status?: number };
        if (statusError.status === 404) {
          return false;
        }
      }
      return failureCount < 3;
    },
  });

  return {
    mealTypePreference: data,
    isLoading,
    isError,
    error,
  };
};
